import React from 'react';
import cn from 'classnames';
import Slider, { Settings } from 'react-slick';
import { useTheme } from '../../../../theme';
import { CompareTableHeader } from '../../../types';
import Fare from './Fare/Fare';
import SlickSlider from '../../../../SlickSlider';

interface Props {
	compareTableHeader: CompareTableHeader;
	settings: Settings;
	isFullFareConditions: boolean;
	contentTableRef: React.RefObject<HTMLDivElement>;
	topSliderRef: React.RefObject<Slider>;
	onSetCurrentSlide: React.Dispatch<React.SetStateAction<number>>;
	selectedFare?: string;
	selectedFareName?: string;
}

const HeaderSlider: React.FC<Props> = ({
	compareTableHeader,
	settings,
	isFullFareConditions,
	onSetCurrentSlide,
	selectedFare,
	selectedFareName,
	contentTableRef,
	topSliderRef
}) => {
	const { FaresSlider: sliderCss, Header: css } = useTheme('CompareFares');

	let isImagesPresentInResponse: boolean;

	const topSliderSettings: Settings = {
		...settings,
		arrows: true,
		afterChange: currentSlide => {
			onSetCurrentSlide(currentSlide);
		}
	};

	if (compareTableHeader) {
		isImagesPresentInResponse = !!compareTableHeader?.[0]?.image;
	}

	React.useEffect(() => {
		if (compareTableHeader) {
			const index = compareTableHeader.findIndex(group => group?.title === selectedFareName);

			onSetCurrentSlide(index > 0 ? index : 0);
		}
	}, [compareTableHeader, selectedFareName]);

	return (
		<div className={css.row}>
			<div className={cn(sliderCss.title, css.headerTitle)}>
				<div className={css.arrows} />
			</div>
			<div
				className={cn(css.row, sliderCss.slider, {
					[css.slider_fullConditions]: isFullFareConditions,
					[css.slider_withoutImages]: !isImagesPresentInResponse
				})}
			>
				<div className={cn(sliderCss.slider)}>
					<SlickSlider {...topSliderSettings} ref={topSliderRef}>
						{compareTableHeader?.map((fare, index) => (
							<Fare
								key={fare.title}
								isFullFareConditions={isFullFareConditions}
								selectedFare={selectedFare}
								fare={fare}
								fareIndex={index}
								contentTableRef={contentTableRef}
							/>
						))}
					</SlickSlider>
				</div>
			</div>
		</div>
	);
};

export default HeaderSlider;
